module.exports = __webpack_public_path__ + "img/dots_darkblue.adc764ac.png";